import type { CenterProps } from '@chakra-ui/react';
import { Center } from '@chakra-ui/react';
import { MessageMentionIcon, Tooltip } from '@halo/ui-chat-react';
import { useTranslation } from 'react-i18next';

interface MentionButtonProps extends CenterProps {
  onClick: () => void;
  props?: CenterProps;
}

export function MentionButton({ onClick, props }: MentionButtonProps) {
  const { t } = useTranslation();
  return (
    <Tooltip
      content={t('chat.tooltipMention')}
      chakraPortal={false}
      openDelay={0}
      closeDelay={0}
      showArrow={true}
    >
      <Center
        h="1.857em"
        w="1.857em"
        cursor="pointer"
        borderRadius="sm"
        _hover={{ bg: 'bg.muted', color: 'brand.100' }}
        transition="all 0.2s"
        onClick={onClick}
        {...props}
      >
        <Center className="shake">
          <MessageMentionIcon />
        </Center>
      </Center>
    </Tooltip>
  );
}
